import { useEffect, useLayoutEffect } from 'react'

// Prevents React warnings in SSR mode. More info: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
export const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect
